<ng-container *ngIf="this.tableDataset.data.length == 0">
    <div class="loading">
        <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner></div
></ng-container>

<ng-container *ngIf="this.tableDataset.data.length > 0">
    <table mat-table [dataSource]="this.tableDataset" class="mat-table-wrapper">
        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? this.masterToggle() : null" [checked]="isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox
                    (change)="this.dataPointCheck(row, $event)"
                    [checked]="selection.isSelected(row)"
                ></mat-checkbox>
            </td>
        </ng-container>

        <!-- ECU ID Column -->
        <ng-container matColumnDef="ecu_id" class="mat-column-ecu-id">
            <th mat-header-cell *matHeaderCellDef>{{ 'MASCHINESTATE.GRAPH.TABLE.ECU_ID' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.identifier.ecu_id }}</td>
        </ng-container>

        <!-- Data ID Column -->
        <ng-container matColumnDef="data_id" class="mat-column-data-id">
            <th mat-header-cell *matHeaderCellDef>{{ 'MASCHINESTATE.GRAPH.TABLE.DATA_ID' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.identifier.data_id }}</td>
        </ng-container>

        <!-- Name column Column -->
        <ng-container matColumnDef="data_name" class="mat-column-data-name">
            <th mat-header-cell *matHeaderCellDef>{{ 'MASCHINESTATE.GRAPH.TABLE.NAME' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>

        <!-- Timestamp Column -->
        <ng-container matColumnDef="timestamp" class="mat-column-timestamp">
            <th mat-header-cell *matHeaderCellDef>{{ 'MASCHINESTATE.GRAPH.TABLE.TIMESTAMP' | translate}}</th>
            <td mat-cell *matCellDef="let row">
                {{ row.timestamp != -1 ? (row.timestamp - 3600000 | date : "HH:mm:ss.SSS") : '-' }}
            </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value" class="mat-column-value">
            <th mat-header-cell *matHeaderCellDef>{{ 'MASCHINESTATE.GRAPH.TABLE.VALUE' | translate}}</th>
            <td mat-cell *matCellDef="let row">{{ row.timestamp != -1 ? row.value : '-' }} {{ row.unit == '-' ? '' : row.unit }}</td>
        </ng-container>

        <!-- Table Extension -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [matTooltip]="'ECU ID: ' + row.identifier.ecu_id + ', Data ID: ' + row.identifier.data_id"
        ></tr>
    </table>
</ng-container>
